import { useCallback, useState } from 'react';
import { devicePreferenceStore } from './devicePreference';

/**
 * O dispositivo preferido de um tipo (`audioinput`, `videoinput` ou `audiooutput`) para o menu da sala: o id guardado, e como
 * guardar ou limpar. A tela é atualizada na hora; o armazenamento é só neste navegador.
 *
 * @param {'audioinput' | 'videoinput' | 'audiooutput'} kind
 * @param {ReturnType<typeof import('./devicePreference').createDevicePreferenceStore>} [store]
 * @returns {{ savedId: string | null, save: (deviceId: string) => void, clear: () => void }}
 */
export function useDevicePreference(kind, store = devicePreferenceStore) {
    const [savedId, setSavedId] = useState(() => store.read()[kind] ?? null);

    const save = useCallback((deviceId) => {
        store.save(kind, deviceId);
        setSavedId(store.read()[kind] ?? null);
    }, [kind, store]);

    const clear = useCallback(() => {
        store.clear(kind);
        setSavedId(null);
    }, [kind, store]);

    return { savedId, save, clear };
}
